<template>
  <v-dialog v-model="dialog" width="1200" persistent>
    <v-card>
      <v-card-title class="primary py-3 pr-5 fixedTop white--text">
        <span class="title">Customer Existing Services</span>
        <v-btn
          absolute
          top
          right
          fab
          dark
          text
          icon
          small
          style="margin: 27px 0 0 0 !important"
          @click="
            $emit('close');
            reset();
          "
        >
          <v-icon color="white--text">clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-flex offset-xs8>
          <v-text-field
            solo
            prepend-inner-icon="search"
            clearable
            v-model="search"
            label="Search"
            hide-details
          ></v-text-field>
        </v-flex>

        <v-data-table
          :headers="headers"
          :items="items.filter(x => x.type === 'VoIP')"
          :search="search"
          class="elevation-1 mt-3"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template v-slot:items="props">
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.service }}</td>
            <td>{{ props.item.plan }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.added | formatDate }}</td>
            <td>{{ props.item.released | formatDate }}</td>
            <td>{{ props.item.contractEnd | formatDate }}</td>
           
            <td>
              <v-checkbox
                v-model="props.item.upgrade"
                hide-details
                color="primary"
                v-if="upgradeable(props.item)"
                @change="addSelected(props.item)"
              ></v-checkbox>
            </td>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          @click="
            selectAllItems();
            disable = !disable;
          "
          :disabled="selectAllDisable"
          class="primary"
        >Select all items (Upgrade)</v-btn>
       
        <v-btn text @click="emitPayload()" :disabled="disable" class="primary">{{ buttonText }}</v-btn>
       
        <v-btn text @click="
            $emit('close');
            reset();
          ">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, createNamespacedHelpers } from "vuex";

const { mapActions: mapIPVoiceActions } = createNamespacedHelpers(
  `orders/ipVoice`
);

export default {
  name: "ExistingServices",
  props: {
    dialog: { type: Boolean },
    account: { type: Number },
    headers: { type: Array }
  },
  data() {
    return {
      rowsPerPageItems: [
        { text: "15", value: 15 },
        { text: "30", value: 30 },
        { text: "45", value: 45 },
        { text: "All", value: -1 }
      ],
      pagination: {
        rowsPerPage: 15
      },
      items: [],
      voip: [],
      totalItems: 0,
      search: "",
      disable: true,

      selected: [],
      selectedSoftphone: [],
      showAll: false,
      selectAllDisable: false,
      selectAllSoftphoneDisable: false,
      buttonText: "Upgrade selected item"
    };
  },
  methods: {
    ...mapIPVoiceActions(["setMessage", "getServices"]),
    upgradeable(service) {
      let allow = false;
      if (service.released) return false;
      if (new Date(service.contractEnd) - new Date() <= 0) allow = true;
      if (!service.contractEnd) allow = true;

      return allow;
    },
    loadServices() {
      this.getServices(this.account).then(data => {
        if (
          data &&
          data.length > 0 &&
          data.some(x => x.type.toUpperCase() == "VOIP")
        ) {
          this.setMessage({ message: "Data loaded!", httpStatus: 200 });
        } else {
          this.setMessage({
            message: "no VoIP services!",
            httpStatus: 200
          });
          this.items = [];
          return this.$emit("loaded", []);
        }
        this.items = data;
        this.$emit("loaded", data);
        if (
          this.items &&
          !this.items.some(
            x =>
              x.type === "VoIP" &&
              !x.plan.toLowerCase().includes("fax") &&
              !x.released
          )
        ) {
          this.selectAllDisable = true;
        }
      });
    },
    addSelected() {
      this.selected = this.items.filter(x => x.upgrade);
    },
    addSelectedSoftphone() {
      this.selectedSoftphone = this.items.filter(x => x.addSoftphone);
    },
    emitPayload() {
      this.$emit("close");
      this.$emit("selectedItems", this.selected);
      this.selected = [];
      this.reset();
    },
    isAllowed(item) {
      if (
        !item.plan.toLowerCase().includes("softphone") &&
        !item.plan.toLowerCase().includes("hunt") &&
        !item.released
      )
        return true;
      else return false;
    },
    emitSelectedSoftphonePayload() {
      this.$emit("close");
      this.$emit("selectedSoftphoneItems", this.selectedSoftphone);
      this.selectedSoftphone = [];
      this.reset();
    },
    reset() {
      this.showAll = false;
      this.disable = true;
      this.selectAllSoftphoneDisable = false;
      this.selectAllDisable = false;
      this.items.forEach(x => {
        x.upgrade = false;
        x.addSoftphone = false;
      });
    },
    selectAllSoftPhoneConferenceItems() {
      let vm = this;
      vm.selectedSoftphone = [];
      vm.items.forEach(x => {
        if (
          x.type === "VoIP" &&
          !x.plan.toLowerCase().includes("softphone") &&
          !x.plan.toLowerCase().includes("hunt") &&
          !x.released
        ) {
          x.addSoftphone = 1;
          vm.selectedSoftphone.push(x);
        }
      });

      this.selectAllSoftphoneDisable = true;
    },
    selectAllItems() {
      let vm = this;
      this.selected = [];
      vm.items.forEach(x => {
        if (
          vm.upgradeable(x) &&
          x.type === "VoIP" &&
          !x.plan.toLowerCase().includes("fax") &&
          !x.released
        ) {
          x.upgrade = true;
          this.selected.push(x);
        }
      });

      this.selectAllDisable = true;
    }
  },
  watch: {
    selected: function() {
      if (this.selected.length == 0) {
        this.disable = true;
      } else {
        this.disable = false;
      }

      if (this.selected.length > 1) {
        this.buttonText = "Upgrade selected items";
      } else {
        this.buttonText = "Upgrade selected item";
      }
    }
  },
  filters: {
    formatDate: function(date) {
      if (!date) return null;

      const [year, month, day] = date.substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    }
  },
  mounted() {
    this.loadServices();
  }
};
</script>

<style>
.fixedTop {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 999;
}
.invalid {
  background-color: coral;
}
</style>
